export default __webpack_public_path__ + "static/media/screen_livechat_22.34489ee3.png";